"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgArcHelper = void 0;
// This is used to generate a line command for a path svg element.
// It will draw a circular arc to represent a percent score from 0 to 100
// SVG Path documentation: https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths
var SvgArcHelper = /** @class */ (function () {
    function SvgArcHelper(centerX, centerY, startDegree, endDegree) {
        this.centerX = centerX;
        this.centerY = centerY;
        this.startDegree = startDegree;
        this.degreeSpan = endDegree - startDegree;
        this.degreeModifier = this.degreeSpan / 360;
    }
    SvgArcHelper.prototype.describeArc = function (radius, startScore, endScore) {
        if (Math.abs(endScore - startScore) >= 100) {
            // paths can't be used to draw a complete circle.
            // so this hack will draw a line just short of a circle by an imperceptible amount.
            startScore = 0;
            endScore = 99.999;
        }
        var startAngle = this.getDegreesFromScore(startScore);
        var endAngle = this.getDegreesFromScore(endScore);
        var start = this.getArcPointFromDegrees(radius, startAngle);
        var end = this.getArcPointFromDegrees(radius, endAngle);
        var arcSweep = endAngle - startAngle <= 180 ? '0' : '1';
        return ['M', start.x, start.y, 'A', radius, radius, 0, arcSweep, 1, end.x, end.y].join(' ');
    };
    SvgArcHelper.prototype.getDegreesFromScore = function (score) {
        return 360 * (score * this.degreeModifier * 0.01) + this.startDegree;
    };
    SvgArcHelper.prototype.getArcPointFromDegrees = function (radius, angleInDegrees) {
        var angleInRadians = ((angleInDegrees - this.degreeSpan) * Math.PI) / 180.0;
        return {
            x: this.centerX + radius * Math.cos(angleInRadians),
            y: this.centerY + radius * Math.sin(angleInRadians),
        };
    };
    return SvgArcHelper;
}());
exports.SvgArcHelper = SvgArcHelper;
